/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MonitEntityTorrentsOrderBy = {
    EntityId: 'entity_id',
    Asset: 'asset',
    SourceAsset: 'source_asset',
    Name: 'name',
    Infohash: 'infohash',
    Shared: 'shared',
    Found: 'found',
    Created: 'created',
    Updated: 'updated',
    Category: 'category'
} as const;
export type MonitEntityTorrentsOrderBy = typeof MonitEntityTorrentsOrderBy[keyof typeof MonitEntityTorrentsOrderBy];


export function MonitEntityTorrentsOrderByFromJSON(json: any): MonitEntityTorrentsOrderBy {
    return MonitEntityTorrentsOrderByFromJSONTyped(json, false);
}

export function MonitEntityTorrentsOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityTorrentsOrderBy {
    return json as MonitEntityTorrentsOrderBy;
}

export function MonitEntityTorrentsOrderByToJSON(value?: MonitEntityTorrentsOrderBy | null): any {
    return value as any;
}

